'use client';
import * as React from 'react';
import { ServiceData } from '@/types/sanity';
import { BookingFlow } from '../booking/BookingFlow';

interface ConsultationButtonProps {
	service: ServiceData;
}

export function ConsultationButton({ service }: ConsultationButtonProps) {
	const [isBookingOpen, setIsBookingOpen] = React.useState(false);

	const handleClick = () => {
		setIsBookingOpen(true);
	};

	return (
		<>
			<button
				className='flex gap-6 items-center self-start py-2 pr-2 pl-6 mt-10 text-base font-bold leading-none text-center bg-[#fbb040] rounded-[100px] max-md:pl-5 hover:bg-[#f8c880] transition-colors'
				onClick={handleClick}
			>
				<span className='self-stretch my-auto'>
					{service.isPOA || service.requiresConsultation
						? 'Book a consultation'
						: 'Book now'}
				</span>
				<img
					src='https://cdn.builder.io/api/v1/image/assets/17cfa75daf82417693353b2f7dd2694b/35513e59d20f830047271add01745364ef5dffe3001c0fd47f11db11df4d5300?placeholderIfAbsent=true'
					alt='Book consultation icon'
					className='object-contain shrink-0 self-stretch my-auto w-12 aspect-square'
				/>
			</button>
			<BookingFlow
				isOpen={isBookingOpen}
				onClose={() => setIsBookingOpen(false)}
				service={service}
			/>
		</>
	);
}
